import React from 'react';
import { User, FileText, History, BarChart3, Wallet, CheckCircle, Calendar, CreditCard, Banknote, TrendingUp, Clock, XCircle } from 'lucide-react';

const ProfileScreen = ({ 
  profileTab, 
  setProfileTab,
  requests,
  history,
  stats,
  loadUserData,
  tg,
  setOrderDetails,
  setCurrentScreen,
  userFirstName,
  userLastName,
  telegramUsername,
  userPhotoUrl
}) => (
  <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-slate-900 p-4">
    <div className="max-w-md mx-auto pt-20">
      <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-3xl shadow-2xl p-8 border border-gray-700">
        {/* Блок с аватаркой и информацией о пользователе */}
        <div className="text-center mb-6">
          <div className="relative inline-block mb-4">
            {userPhotoUrl ? (
              <img 
                src={userPhotoUrl} 
                alt="Profile" 
                className="w-20 h-20 rounded-full border-4 border-purple-700/50 shadow-lg object-cover"
              />
            ) : (
              <div className="inline-block bg-purple-900/50 rounded-full p-4 border border-purple-700/50">
                <User className="w-12 h-12 text-purple-400" />
              </div>
            )}
          </div>
          <h2 className="text-2xl font-bold text-white mb-1">
            {userFirstName && userLastName ? `${userFirstName} ${userLastName}` : 'Личный кабинет'}
          </h2>
          {telegramUsername && (
            <p className="text-purple-400 text-sm mb-2">@{telegramUsername}</p>
          )}
          <p className="text-gray-400 text-sm">Управление заявками и статистика</p>
        </div>

        {/* Табы */}
        <div className="flex gap-2 mb-6 bg-gray-900/50 rounded-xl p-1 border border-gray-700">
          <button
            onClick={() => setProfileTab('requests')}
            className={`flex-1 py-2 px-3 rounded-lg font-semibold text-sm transition-all ${
              profileTab === 'requests'
                ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-lg'
                : 'text-gray-400 hover:text-gray-200'
            }`}
          >
            <FileText className="w-4 h-4 inline mr-1" />
            Заявки
          </button>
          <button
            onClick={() => setProfileTab('history')}
            className={`flex-1 py-2 px-3 rounded-lg font-semibold text-sm transition-all ${
              profileTab === 'history'
                ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-lg'
                : 'text-gray-400 hover:text-gray-200'
            }`}
          >
            <History className="w-4 h-4 inline mr-1" />
            История
          </button>
          <button
            onClick={() => setProfileTab('stats')}
            className={`flex-1 py-2 px-3 rounded-lg font-semibold text-sm transition-all ${
              profileTab === 'stats'
                ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-lg'
                : 'text-gray-400 hover:text-gray-200'
            }`}
          >
            <BarChart3 className="w-4 h-4 inline mr-1" />
            Статистика
          </button>
        </div>

        {/* Контент табов */}
        <div className="space-y-4">
          {profileTab === 'requests' && (
            <div>
              {(() => {
                // Фильтруем только активные заявки (не завершенные и не отмененные)
                const activeRequests = requests.filter(
                  req => req.status !== 'completed' && req.status !== 'cancelled'
                );
                
                return (
                  <>
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="font-semibold text-white flex items-center gap-2">
                        <Clock className="w-5 h-5 text-blue-400" />
                        Активные заявки
                      </h3>
                      <span className="text-sm text-gray-400">{activeRequests.length} активных</span>
                    </div>
                    {activeRequests.length === 0 ? (
                      <div className="text-center py-12 text-gray-500">
                        <div className="bg-gray-800/50 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
                          <FileText className="w-10 h-10 opacity-30" />
                        </div>
                        <p className="text-lg font-medium">Нет активных заявок</p>
                        <p className="text-sm text-gray-600 mt-2">Создайте новую заявку для пополнения</p>
                      </div>
                    ) : (
                      <div className="space-y-3">
                        {activeRequests.map((request) => (
                    <div key={request.id} className="w-full">
                      <button
                        onClick={() => {
                          console.log('🔍 ProfileScreen: request object:', request);
                          console.log('🔍 request.id:', request.id);
                          console.log('🔍 request.orderId:', request.orderId);
                          console.log('🔍 request.order_id:', request.order_id);
                          
                          const orderData = {
                            orderId: request.id || request.orderId || request.order_id,
                            type: request.type,
                            amount: request.amount,
                            paymentMethod: request.paymentMethod,
                            bank: request.bank || '',
                            network: request.network || '',
                            fullName: request.fullName || '',
                            status: request.status
                          };
                          console.log('📦 ProfileScreen: Открываем заказ', orderData);
                          console.log('📦 orderData.orderId:', orderData.orderId);
                          setOrderDetails(orderData);
                          setCurrentScreen('orderConfirmation');
                        }}
                        className="w-full bg-gradient-to-r from-gray-700/50 to-gray-800/50 rounded-xl p-5 hover:shadow-lg hover:from-gray-700 hover:to-gray-800 border border-gray-600 hover:border-purple-600/50 transition-all cursor-pointer text-left group"
                      >
                        {/* Верхняя строка: Тип и Статус */}
                        <div className="flex justify-between items-start mb-3">
                          <div>
                            <p className="font-bold text-white text-lg group-hover:text-purple-300 transition-colors">
                              {request.type}
                            </p>
                            <p className="text-xs text-gray-500 mt-0.5">
                              Заявка № {request.id || request.orderId || request.order_id}
                            </p>
                          </div>
                          <span className={`px-3 py-1 rounded-full text-xs font-semibold border ${
                            request.status === 'pending' 
                              ? 'bg-yellow-900/50 text-yellow-300 border-yellow-700'
                              : request.status === 'processing'
                              ? 'bg-blue-900/50 text-blue-300 border-blue-700'
                              : request.status === 'completed'
                              ? 'bg-green-900/50 text-green-300 border-green-700'
                              : request.status === 'cancelled'
                              ? 'bg-red-900/50 text-red-300 border-red-700'
                              : 'bg-gray-700 text-gray-300'
                          }`}>
                            {request.status === 'pending' ? 'Ожидает' : 
                             request.status === 'processing' ? 'В обработке' :
                             request.status === 'completed' ? 'Завершено' :
                             request.status === 'cancelled' ? 'Отменено' :
                             request.status}
                          </span>
                        </div>

                        {/* Разделитель */}
                        <div className="h-px bg-gradient-to-r from-transparent via-gray-600 to-transparent mb-3"></div>

                        {/* Нижняя строка: Дата, Метод оплаты, Сумма */}
                        <div className="flex justify-between items-center">
                          <div className="flex items-center gap-3">
                            <div className="flex items-center gap-1.5 text-sm text-gray-400">
                              <Calendar className="w-3.5 h-3.5" />
                              <span>{request.date || 'Нет даты'}</span>
                            </div>
                            <div className={`px-2.5 py-1 rounded-lg text-xs font-semibold ${
                              request.paymentMethod === 'RUB' 
                                ? 'bg-green-900/30 text-green-400 border border-green-700/50'
                                : 'bg-orange-900/30 text-orange-400 border border-orange-700/50'
                            }`}>
                              {request.paymentMethod}
                            </div>
                          </div>
                          <span className="font-bold text-purple-400 text-lg">
                            {request.amount} ¥
                          </span>
                        </div>
                      </button>
                    </div>
                        ))}
                      </div>
                    )}
                  </>
                );
              })()}
            </div>
          )}

          {profileTab === 'history' && (
            <div>
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-semibold text-white flex items-center gap-2">
                  <CheckCircle className="w-5 h-5 text-green-400" />
                  История пополнений
                </h3>
                <span className="text-sm text-gray-400">{history.length} операций</span>
              </div>
              {history.length === 0 ? (
                <div className="text-center py-12 text-gray-500">
                  <div className="bg-gray-800/50 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
                    <History className="w-10 h-10 opacity-30" />
                  </div>
                  <p className="text-lg font-medium">История пуста</p>
                  <p className="text-sm text-gray-600 mt-2">Ваши завершенные операции появятся здесь</p>
                </div>
              ) : (
                <div className="space-y-3">
                  {history.map((item) => (
                    <div 
                      key={item.id} 
                      className="bg-gradient-to-br from-gray-800/80 to-gray-900/80 rounded-2xl p-5 border border-gray-700/50 hover:border-purple-600/50 hover:shadow-lg hover:shadow-purple-900/20 transition-all duration-300 group"
                    >
                      {/* Верхняя часть - тип и дата */}
                      <div className="flex items-start justify-between mb-4">
                        <div className="flex items-center gap-3">
                          {/* Иконка типа платежа */}
                          <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${
                            item.type === 'Alipay' 
                              ? 'bg-blue-500/20 border border-blue-500/30' 
                              : 'bg-green-500/20 border border-green-500/30'
                          }`}>
                            <Wallet className={`w-6 h-6 ${
                              item.type === 'Alipay' ? 'text-blue-400' : 'text-green-400'
                            }`} />
                          </div>
                          
                          <div>
                            <p className="font-bold text-white text-lg group-hover:text-purple-300 transition-colors">
                              {item.type}
                            </p>
                            <div className="flex items-center gap-1.5 text-sm text-gray-400 mt-0.5">
                              <Calendar className="w-3.5 h-3.5" />
                              <span>{item.date}</span>
                            </div>
                          </div>
                        </div>

                        {/* Галочка завершения */}
                        <div className="bg-green-500/20 rounded-full p-1.5 border border-green-500/30">
                          <CheckCircle className="w-5 h-5 text-green-400" />
                        </div>
                      </div>

                      {/* Разделитель */}
                      <div className="h-px bg-gradient-to-r from-transparent via-gray-700 to-transparent mb-4"></div>

                      {/* Средняя часть - суммы */}
                      <div className="grid grid-cols-2 gap-4 mb-4">
                        <div className="bg-purple-900/20 rounded-xl p-3 border border-purple-800/30">
                          <p className="text-xs text-purple-400 font-medium mb-1 flex items-center gap-1">
                            <span className="text-base">¥</span> CNY
                          </p>
                          <p className="text-2xl font-bold text-white">
                            {item.amount}
                          </p>
                        </div>
                        
                        <div className="bg-indigo-900/20 rounded-xl p-3 border border-indigo-800/30">
                          <p className="text-xs text-indigo-400 font-medium mb-1 flex items-center gap-1">
                            <span className="text-base">₽</span> RUB
                          </p>
                          <p className="text-2xl font-bold text-white">
                            {item.rub || '—'}
                          </p>
                        </div>
                      </div>

                      {/* Нижняя часть - способ оплаты */}
                      <div className="flex items-center gap-2 bg-gray-900/50 rounded-lg px-3 py-2">
                        {item.paymentMethod === 'RUB' ? (
                          <Banknote className="w-4 h-4 text-green-400" />
                        ) : (
                          <CreditCard className="w-4 h-4 text-orange-400" />
                        )}
                        <span className="text-sm text-gray-400">Способ оплаты:</span>
                        <span className={`text-sm font-semibold ${
                          item.paymentMethod === 'RUB' ? 'text-green-400' : 'text-orange-400'
                        }`}>
                          {item.paymentMethod}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {profileTab === 'stats' && (
            <div>
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-semibold text-white flex items-center gap-2">
                  <TrendingUp className="w-5 h-5 text-indigo-400" />
                  Статистика
                </h3>
              </div>

              {/* Основные метрики */}
              <div className="grid grid-cols-2 gap-3 mb-4">
                {/* Всего заявок */}
                <div className="bg-gradient-to-br from-blue-900/40 to-indigo-900/40 rounded-2xl p-4 border border-blue-700/50 hover:border-blue-600/70 transition-all">
                  <div className="flex items-center gap-2 mb-3">
                    <div className="bg-blue-500/20 rounded-lg p-2">
                      <FileText className="w-5 h-5 text-blue-400" />
                    </div>
                    <p className="text-xs text-blue-300 font-medium">Всего заявок</p>
                  </div>
                  <p className="text-3xl font-bold text-white">{stats.totalRequests}</p>
                </div>

                {/* Завершенные */}
                <div className="bg-gradient-to-br from-green-900/40 to-emerald-900/40 rounded-2xl p-4 border border-green-700/50 hover:border-green-600/70 transition-all">
                  <div className="flex items-center gap-2 mb-3">
                    <div className="bg-green-500/20 rounded-lg p-2">
                      <CheckCircle className="w-5 h-5 text-green-400" />
                    </div>
                    <p className="text-xs text-green-300 font-medium">Завершено</p>
                  </div>
                  <p className="text-3xl font-bold text-white">{stats.completedRequests || 0}</p>
                </div>

                {/* В ожидании */}
                <div className="bg-gradient-to-br from-yellow-900/40 to-orange-900/40 rounded-2xl p-4 border border-yellow-700/50 hover:border-yellow-600/70 transition-all">
                  <div className="flex items-center gap-2 mb-3">
                    <div className="bg-yellow-500/20 rounded-lg p-2">
                      <Clock className="w-5 h-5 text-yellow-400" />
                    </div>
                    <p className="text-xs text-yellow-300 font-medium">В ожидании</p>
                  </div>
                  <p className="text-3xl font-bold text-white">{stats.pendingRequests || 0}</p>
                </div>

                {/* Отменено */}
                <div className="bg-gradient-to-br from-red-900/40 to-pink-900/40 rounded-2xl p-4 border border-red-700/50 hover:border-red-600/70 transition-all">
                  <div className="flex items-center gap-2 mb-3">
                    <div className="bg-red-500/20 rounded-lg p-2">
                      <XCircle className="w-5 h-5 text-red-400" />
                    </div>
                    <p className="text-xs text-red-300 font-medium">Отменено</p>
                  </div>
                  <p className="text-3xl font-bold text-white">{stats.cancelledRequests || 0}</p>
                </div>
              </div>

              {/* Разделитель */}
              <div className="h-px bg-gradient-to-r from-transparent via-gray-700 to-transparent my-5"></div>

              {/* Суммы */}
              <div className="space-y-3">
                {/* Общая сумма в юанях */}
                <div className="bg-gradient-to-r from-purple-900/30 to-pink-900/30 rounded-2xl p-5 border border-purple-700/50 hover:border-purple-600/70 hover:shadow-lg hover:shadow-purple-900/20 transition-all group">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="bg-purple-800/50 rounded-xl p-3">
                        <Wallet className="w-6 h-6 text-purple-400" />
                      </div>
                      <div>
                        <p className="text-sm text-purple-300 font-medium mb-1">Общая сумма</p>
                        <p className="text-xs text-gray-500">в юанях (CNY)</p>
                      </div>
                    </div>
                    <div className="text-right">
                      <p className="text-3xl font-bold text-white group-hover:text-purple-300 transition-colors">
                        {stats.totalAmountCNY.toLocaleString()}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Общая сумма в рублях */}
                <div className="bg-gradient-to-r from-indigo-900/30 to-blue-900/30 rounded-2xl p-5 border border-indigo-700/50 hover:border-indigo-600/70 hover:shadow-lg hover:shadow-indigo-900/20 transition-all group">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="bg-indigo-800/50 rounded-xl p-3">
                        <BarChart3 className="w-6 h-6 text-indigo-400" />
                      </div>
                      <div>
                        <p className="text-sm text-indigo-300 font-medium mb-1">Общая сумма</p>
                        <p className="text-xs text-gray-500">в рублях (RUB)</p>
                      </div>
                    </div>
                    <div className="text-right">
                      <p className="text-3xl font-bold text-white group-hover:text-indigo-300 transition-colors">
                        {stats.totalAmountRUB.toLocaleString()}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
);

export default ProfileScreen;

